import React, { useEffect, useState } from "react";
import { Typography, Pagination } from "antd";
import "./AppList.css";
import { GetAppsOverallDataRequest } from "../proto/brevis_explorer/statistics_pb";
import { getAppsOverallData } from "../store/grpc_client";
import styled, { keyframes } from "styled-components";

const { Title } = Typography;

interface AppData {
  displayName: string;
  iconUrl: string;
  description: string;
  last24hAppRequests: number;
  last24hProofs: number;
  last24hUniqAddress: number;
  totalAppRequests: number;
  totalProofs: number;
  totalUniqAddress: number;
  link: string;
}

const AppList: React.FC = () => {
  const [appsData, setAppsData] = useState<AppData[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const pageSize = 10;

  useEffect(() => {
    let req = new GetAppsOverallDataRequest();
    getAppsOverallData(req).then((res) => {
      if (res) {
        const { appOverallStatisticsList } = res.toObject();
        let data: AppData[] = [];
        appOverallStatisticsList.forEach((appOverallStatistics: any) => {
          // console.log("appOverallStatisticsList", appOverallStatisticsList);
          const {
            link,
            iconUrl,
            description,
            displayName,
            last24hAppRequests,
            last24hProofs,
            last24hUniqAddress,
            totalAppRequests,
            totalProofs,
            totalUniqAddress,
          } = appOverallStatistics;
          data.push({
            displayName,
            iconUrl,
            description,
            last24hAppRequests,
            last24hProofs,
            last24hUniqAddress,
            totalAppRequests,
            totalProofs,
            totalUniqAddress,
            link,
          });
        });

        data.sort((a, b) => {
          if (a.displayName === "JOJO") return 1;
          if (b.displayName === "JOJO") return -1;
          if (a.displayName === "Kwenta") return 1;
          if (b.displayName === "Kwenta") return -1;

          return b.totalProofs - a.totalProofs;
        });

        setAppsData(data);
      }
    });
  }, []);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const currentData = appsData.slice(
    (currentPage - 1) * pageSize,
    currentPage * pageSize
  );

  const gradient = keyframes`
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -100% 0;
  }
`;

  const LoadingText = styled.span`
    font-size: 24px;
    font-weight: bold;
    background: linear-gradient(to right, #2e323d, #7b86a3, #2e323d);
    background-size: 200% 100%;
    background-clip: text;
    -webkit-background-clip: text;
    color: transparent;
    animation: ${gradient} 3s linear infinite;
  `;

  return (
    <div className="app-list-section">
      <Title level={4} className="section-title">
        Brevis Powered Apps
      </Title>
      {currentData.length === 0 ? (
        <div className="loading">
          <img src={"/loading.svg"} alt="" style={{ width: 58, height: 58 }} />
          <LoadingText>loading...</LoadingText>
        </div>
      ) : (
        currentData.map((app) => (
          <div className="app-card">
            <div className="app-card_header">
              <img className="app-avatar" src={app.iconUrl} alt="iconUrl" />
              <div className="app-details">
                <div className="app-name">
                  {app.displayName.toUpperCase()}
                  <span onClick={() => window.open(app.link, "_blank")}>
                    <img
                      className="export-icon"
                      src="/export.svg"
                      alt="export"
                      width="12"
                    />
                  </span>
                </div>
                <div className="app-description">{app.description}</div>
              </div>
            </div>
            <div className="app-card_header_small">
              <div className="app-title">
                <img className="app-avatar" src={app.iconUrl} alt="iconUrl" />
                <div className="app-name">
                  {app.displayName.toUpperCase()}
                  <span onClick={() => window.open(app.link, "_blank")}>
                    <img
                      className="export-icon"
                      src="/export.svg"
                      alt="export"
                      width="12"
                    />
                  </span>
                </div>
              </div>
              <div className="app-details">
                <div className="app-description">{app.description}</div>
              </div>
            </div>
            <div className="app-card-stats">
              <div className="stats-group">
                <div className="stat-label">Number of Proofs (all time)</div>
                <div className="stat-value">
                  {app.totalProofs.toLocaleString()}
                </div>
              </div>
              <div className="stats-group">
                <div className="stat-label">
                  Number of App Requests (all time)
                </div>
                <div className="stat-value">
                  {app.totalAppRequests.toLocaleString()}
                </div>
              </div>
              <div className="stats-group">
                <div className="stat-label">Unique Addresses (all time)</div>
                <div className="stat-value">
                  {app.totalUniqAddress.toLocaleString()}
                </div>
              </div>
              <div className="stats-group">
                <div className="stat-label">Number of Proofs (24h)</div>
                <div className="stat-value">
                  {app.last24hProofs.toLocaleString()}
                </div>
              </div>
              <div className="stats-group">
                <div className="stat-label">Number of Requests (24h)</div>
                <div className="stat-value">
                  {app.last24hAppRequests.toLocaleString()}
                </div>
              </div>
              <div className="stats-group">
                <div className="stat-label">Unique Addresses (24h)</div>
                <div className="stat-value">
                  {app.last24hUniqAddress.toLocaleString()}
                </div>
              </div>
            </div>
          </div>
        ))
      )}
      {currentData.length !== 0 && (
        <div className="pagination-container">
          <Pagination
            current={currentPage}
            onChange={handlePageChange}
            total={appsData.length}
            pageSize={pageSize}
            showSizeChanger={false}
          />
        </div>
      )}
    </div>
  );
};

export default AppList;
